import { render, staticRenderFns } from "./ProductHighlight.vue?vue&type=template&id=21f28908&"
import script from "./ProductHighlight.vue?vue&type=script&lang=js&"
export * from "./ProductHighlight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\DevOpsAgent\\agent1\\_work\\10\\s\\Site\\Source\\Web\\Marketing.UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21f28908')) {
      api.createRecord('21f28908', component.options)
    } else {
      api.reload('21f28908', component.options)
    }
    module.hot.accept("./ProductHighlight.vue?vue&type=template&id=21f28908&", function () {
      api.rerender('21f28908', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Views/Marketing/Next/ContentBlock/ProductHighlight/ProductHighlight.vue"
export default component.exports